module.exports = __webpack_public_path__ + "img/ehealth-logo-szines.cf822109.png";